import { Component } from '@theme/component';

/**
 * Collection banner with a teased description.
 *
 * Collapsed, the description is clamped to a few lines next to the collection image. When the
 * trigger is activated, the `expanded` attribute is flipped on the host: CSS then lets the
 * (white) content column cover the image and reveals the full description with a height
 * transition. Activating the trigger again collapses it back.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} triggers - The "more"/"less" trigger buttons.
 *
 * @extends Component<Refs>
 */
class CollectionBanner extends Component {
  /**
   * Toggles the expanded state of the banner and keeps the triggers' aria-expanded in sync.
   */
  toggle = () => {
    const expanded = this.hasAttribute('expanded');
    this.toggleAttribute('expanded', !expanded);

    for (const trigger of this.refs.triggers ?? []) {
      trigger.setAttribute('aria-expanded', String(!expanded));
    }
  };
}

if (!customElements.get('collection-banner')) {
  customElements.define('collection-banner', CollectionBanner);
}
